import { render, staticRenderFns } from "./ListSolutions.vue?vue&type=template&id=71ea064c&scoped=true&"
import script from "./ListSolutions.vue?vue&type=script&lang=ts&"
export * from "./ListSolutions.vue?vue&type=script&lang=ts&"
import style0 from "./ListSolutions.vue?vue&type=style&index=0&id=71ea064c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ea064c",
  null
  
)

export default component.exports